import React from "react";
import { Box, Flex } from "@chakra-ui/react";
import Sidebar from "../../Components/Sidebar";
import Navbar from "../../Components/Navbar";
import ReturnReport from "./ReturnReport";

const Returns = () => {
  return (
    <Flex>
      <Sidebar />
      <Box flex="1" p="4">
        <Navbar />
        <ReturnReport />
      </Box>
    </Flex>
  );
};

export default Returns;
